export default __webpack_public_path__ + "static/media/Eski Shahar.fec36b70.jpg";